import { render, staticRenderFns } from "./PortfolioUnrankInfo.vue?vue&type=template&id=ff9431ce&scoped=true"
import script from "./PortfolioUnrankInfo.vue?vue&type=script&lang=js"
export * from "./PortfolioUnrankInfo.vue?vue&type=script&lang=js"
import style0 from "./PortfolioUnrankInfo.vue?vue&type=style&index=0&id=ff9431ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9431ce",
  null
  
)

export default component.exports